import { fork } from 'redux-saga/effects';
import asyncCafe from './cafe/sagas'


export default function* rootSaga() {
    yield fork(asyncCafe);
}
